import React from "react";
import {motion} from 'framer-motion';

const animations = {
    initial: { opacity: 0, x: -10 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 10 },
};

const AnimatedPage:React.FC<{children: React.ReactNode}> = ({ children }) => {
    return (
        <motion.div
            variants={animations}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
            style={{width:'100%', height:'100%'}}
        >
            {children}
        </motion.div>
    );
};
export default AnimatedPage;